import React, { useState, useEffect } from 'react';
import {
  Layout, LogoutOutlined, Input, Select,
  Menu, useDispatch, useSelector, Avatar, Dropdown, CaretDownOutlined, SettingFilled, UserOutlined, MenuOutlined, SearchOutlined, Spin
} from './AntComponent';
import '../assets/styles/Layout.scss';
import { useNavigate, useLocation } from 'react-router-dom';
import shortLogo from '../assets/images/shortLogo.svg';
import { userProfile } from '../store/actions/userProfileAction';
import userImage from '../assets/images/user-img.jpg';
import GarudaLogo from '../assets/images/newlogo.svg';

const { Search } = Input;
const { Header, Sider, Content, Footer } = Layout;

export default function LayoutScreen({ children }) {

  const location = useLocation();
  const { profileInfo, loading } = useSelector(state => state.userPrf);
  const tenantName = profileInfo?.data?.employeeDetail[0]?.fullName||"";
  const appuserName = profileInfo?.data?.appUser?.appuserName||"";
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const appUserID = localStorage.getItem("appUserID");
  const dispatch = useDispatch();
  const [current, setCurrent] = useState("/dashboard");
  const url = window.location.href;
  const lastSegment = url.substring(url.lastIndexOf("/") + 1);
  const val = profileInfo !== null ? profileInfo?.data?.entService : [];
  useEffect(() => {
    dispatch(userProfile(appUserID));
  }, [dispatch]);

  useEffect(() => {
    if (location) {
      if (current !== location.pathname) {
        setCurrent(location.pathname);
      }
    }
  }, [location, current]);

  const menuItems = [
    { key: '1', label: 'Profile', icon: <UserOutlined className='text-primary' /> },
    { key: '2', label: 'Settings', icon: <SettingFilled className='text-primary' /> },
    { key: '3', label: 'Logout', icon: <LogoutOutlined className='text-primary' /> },
  ];

  const handleMenuClick = (e) => {
    if (e.key === "2") {
      navigate('/project-settings');
    } else if (e.key === "3") {
      authLogout();
    }
  };
  const handleLogoClick = (e) =>{
    navigate('/company-profile')
  }

  function getItem(label, key, icon, children) {
    return {
      key,
      icon,
      children,
      label,
    };
  };
  const menu = val?.map((item, index) =>{
    if(item?.subMenu.length === 0){
      return (
        getItem(item.serviceName, `/${item.resourceAction}`,
        <img  src={lastSegment == item.resourceAction ?require(`../assets/images/${item.menuIconV2}.svg`)  : require(`../assets/images/active-icons/${item.menuIcon}.svg`)} />
        )
      )
    }
    else{
      if (item?.resourceAction === '#') {
        return  getItem(item.serviceName, index,
        <img  src={lastSegment == item.resourceAction ?require(`../assets/images/${item.menuIconV2}.svg`)  : require(`../assets/images/active-icons/${item.menuIcon}.svg`)} />,
        item?.subMenu.map((submenu )=>{
          return getItem(submenu.serviceName, `/${submenu.resourceAction}`);
        })
      )
      } else {
        return getItem(item.serviceName, `/${item.resourceAction}`,
        <img  src={lastSegment == item.resourceAction ?require(`../assets/images/${item.menuIconV2}.svg`)  : require(`../assets/images/active-icons/${item.menuIcon}.svg`)} />,
        item?.subMenu.map((submenu )=>{
          return getItem(submenu.serviceName, `/${submenu.resourceAction}`);
      }
     ))
    }
  }})

  const authLogout = () => {
    window.location.href = '/login';
    localStorage.clear();
    navigate('/login');
  };

  return (
    <Layout>
      <Sider collapsible collapsed={collapsed} onCollapse={(value) => setCollapsed(value)} className='shadow-sm'>
        <div className="demo-logo-vertical px-0 pt-1 mb-4 bg-white text-center">
          {/* <img src={shortLogo} alt="demo" height={45} width={45} /> */}
          {/* width 195 height 55 */}
          <img src={GarudaLogo} onClick={handleLogoClick} alt="login logo" width="90%" />
        </div>
        {loading ? (
        <Spin size="large" className='d-flex justify-content-center align-items-center h-50'/>
        ) : (
          <Menu mode="vertical" className={`${lastSegment}`} onClick={({ key }) => { navigate(key); }} defaultSelectedKeys={[current]}
            items={menu} />
        )}
      </Sider>
      <Layout>
        <Header className='bg-white pe-3 shadow-sm ms-1 ps-1'>
          <div className='row m-0 '>
            <div className='col d-flex text-start'>
              <MenuOutlined className='me-2 my-auto text-secondary' />
              <h6 className='my-auto text-capitalize text-primary'>{lastSegment}</h6>
            </div>
            <div className='col ms-auto d-flex'>
              <Input
                className="col-md-4 my-auto ms-auto"
                placeholder="Search"
                prefix={<SearchOutlined />}
              />
              <Select
                className='col-auto my-auto mx-2'
                defaultValue="IND"
                suffixIcon={<CaretDownOutlined/>}
                options={[
                  {
                    value: 'IND',
                    label: 'IND',
                  },
                  {
                    value: 'US',
                    label: 'US',
                  },
                ]}
              />
              <Dropdown menu={{
                onClick: handleMenuClick,
                items: menuItems,
              }} trigger={['click']} className='col-auto'>
                <a className="ant-dropdown-link text-decoration-none text-dark" onClick={(e) => e.preventDefault()}>
                  <Avatar src={userImage} className='user-img' />
                  <span>
                  <span className='ms-1 tenantname'>{tenantName}
                  {/* <span>{appuserName}</span> */}
                  </span>
                 
                  </span>
                  {/* <DownOutlined className='ms-1 down-icon' /> */}
                </a>
              </Dropdown>
            </div>
          </div>
        </Header>
        <Content className='content mainContent'>
          <div className=' p-3'>
            {children}
          </div>
        </Content>
        {/* <Footer className='text-center'>
          Kosoft IT Solutions Pvt. Ltd@2023
        </Footer> */}
      </Layout>
    </Layout>
  )
}